import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { useAuth } from '../context/AuthContext';

const LoginPage = lazy(() => import('../pages/Login/LoginPage'));
const DashboardPage = lazy(() => import('../pages/Dashboard/DashboardPage'));
const CategoryList = lazy(() => import('../pages/Categories/CategoryList'));
const CategoryForm = lazy(() => import('../pages/Categories/CategoryForm'));
const UserList = lazy(() => import('../pages/Users/UserList'));
const UserForm = lazy(() => import('../pages/Users/UserForm'));
const AttributeList = lazy(() => import('../pages/Attributes/AttributeList'));
const AttributeForm = lazy(() => import('../pages/Attributes/AttributeForm'));
const ProductList = lazy(() => import('../pages/Products/ProductList'));
const ProductForm = lazy(() => import('../pages/Products/ProductForm'));
const CustomerList = lazy(() => import('../pages/Customers/CustomerList'));
const CustomerForm = lazy(() => import('../pages/Customers/CustomerForm'));
const CustomerDetails = lazy(() => import('../pages/Customers/CustomerDetails'));
const AdSpendList = lazy(() => import('../pages/AdSpends/AdSpendList'));
const OrderList = lazy(() => import('../pages/Orders/OrderList'));
const OrderEditPage = lazy(() => import('../pages/Orders/OrderEditPage'));
const EnquiryList = lazy(() => import('../pages/Enquiries/EnquiryList'));
const EnquiryDetails = lazy(() => import('../pages/Enquiries/EnquiryDetails'));

const AppRoutes = () => {
    const { user } = useAuth();
    return (
        <Suspense fallback={<div className="loading-screen">Loading...</div>}>
            <Routes>
                <Route path="/login" element={<LoginPage />} />

                <Route element={<Layout />}>
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/orders" element={<OrderList />} />
                    <Route path="/orders/edit/:id" element={<OrderEditPage />} />
                    <Route path="/products" element={<ProductList />} />
                    <Route path="/products/new" element={<ProductForm />} />
                    <Route path="/products/edit/:id" element={<ProductForm />} />
                    <Route path="/categories" element={<CategoryList />} />
                    <Route path="/categories/new" element={<CategoryForm />} />
                    <Route path="/categories/edit/:id" element={<CategoryForm />} />
                    <Route path="/attributes" element={<AttributeList />} />
                    <Route path="/attributes/new" element={<AttributeForm />} />
                    <Route path="/attributes/edit/:id" element={<AttributeForm />} />
                    <Route path="/users" element={<UserList />} />
                    <Route path="/users/new" element={<UserForm />} />
                    <Route path="/users/edit/:id" element={<UserForm />} />
                    <Route path="/customers" element={<CustomerList />} />
                    <Route path="/customers/new" element={<CustomerForm />} />
                    <Route path="/customers/edit/:id" element={<CustomerForm />} />
                    <Route path="/customers/view/:id" element={<CustomerDetails />} />
                    <Route 
                        path="/ad-spends" 
                        element={user?.role?.name === 'super_admin' ? <AdSpendList /> : <Navigate to="/orders" replace />} 
                    />
                    <Route path="/enquiries" element={<EnquiryList />} />
                    <Route path="/enquiries/:id" element={<EnquiryDetails />} />
                    <Route path="/settings" element={<div>Settings Page (Coming Soon)</div>} />
                </Route>

                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </Suspense>
    );
};

export default AppRoutes;
